export const mutations = {
  SET_DIALOG_STATE(state, isOpen) {
    state.dialogState = isOpen;
  },
  SET_DIALOG_LOADING(state, isLoading) {
    state.dialogLoading = isLoading
  }
};